// extracted by mini-css-extract-plugin
module.exports = {"blockSection":"SectionContent_blockSection__ICMFh","border":"SectionContent_border__20qtu","placeholderShimmer":"SectionContent_placeholderShimmer__2bkVM"};